import React from 'react'
import { useMutation } from '@apollo/client'
import { useSnackbar } from 'notistack'
import { useFieldArray, useForm } from 'react-hook-form'
import { makeStyles } from '@material-ui/core/styles'
import Box from '@material-ui/core/Box'
import StudentRow from './student-row'
import Button from '@material-ui/core/Button'
import LoadingButton from 'components/loading-button'
import { UPSERT_GRADUATE_STATUS } from './queries'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minHeight: 0,
    marginTop: theme.spacing(1),
  },
  list: {
    overflowY: 'auto',
    maxHeight: '50vh',
    [theme.breakpoints.down('sm')]: {
      flex: 1,
      minHeight: 0,
      maxHeight: 'none',
    },
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(1),
    flexShrink: 0,
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(2),
      marginBottom: 0,
      paddingTop: theme.spacing(2),
    },
  },
}))

const GraduateForm = ({ event, enrollments, closeDialog, refetch }) => {
  const classes = useStyles()
  const activeEnrollments = enrollments.filter(e => !e.isCanceled)
  const students = activeEnrollments.map(e => e.student)
  const { enqueueSnackbar } = useSnackbar()
  const [loading, setLoading] = React.useState(false)
  const form = useForm({
    defaultValues: {
      students: students,
    },
  })
  const { handleSubmit, control, register } = form
  const { fields } = useFieldArray({
    control,
    name: 'students',
  })

  const [upsertGraduateStatus] = useMutation(UPSERT_GRADUATE_STATUS)

  const handleSave = formValues => {
    setLoading(true)
    Promise.all(
      formValues.students.map(student =>
        upsertGraduateStatus({
          variables: {
            status: student.status,
            eventId: event.id,
            studentId: student.id,
          },
        }),
      ),
    )
      .then(resp => {
        const isSuccess = resp.every(r => r.data?.upsertGraduateStatus?.success)
        refetch()
        if (isSuccess) {
          enqueueSnackbar('Graduate Status updated successfully', {
            variant: 'success',
          })
        } else {
          enqueueSnackbar('Error updating Graduate Status', {
            variant: 'error',
          })
        }
      })
      .catch(e => {
        enqueueSnackbar('Error updating Graduate Status', { variant: 'error' })
      })
      .finally(() => {
        setLoading(false)
      })
  }

  return (
    <Box className={classes.root}>
      <Box className={classes.list}>
        {fields.map((student, index) => (
          <StudentRow
            student={student}
            sessions={event.sessions}
            key={student.id}
            register={register}
            index={index}
            eventId={event.id}
          />
        ))}
      </Box>
      <Box className={classes.actions}>
        <Button
          color="primary"
          style={{ marginRight: '8px' }}
          onClick={() => closeDialog()}
        >
          Cancel
        </Button>
        <LoadingButton
          variant="contained"
          color="primary"
          onClick={handleSubmit(handleSave)}
          loading={loading}
        >
          Update Status
        </LoadingButton>
      </Box>
    </Box>
  )
}

export default GraduateForm
